import React, { useState } from 'react';

/**
 * HeaderActions component
 * This component extracts the dialog functionality from NotionHeader
 * to break circular dependencies
 */
export const useHeaderActions = () => {
  // Estados para los diálogos
  const [openNewTransactionDialog, setOpenNewTransactionDialog] = useState(false);
  const [openImportDialog, setOpenImportDialog] = useState(false);

  const handleNewButtonClick = () => {
    setOpenNewTransactionDialog(true);
  };

  const handleCloseNewTransactionDialog = () => {
    setOpenNewTransactionDialog(false);
  };
  
  const handleImportButtonClick = () => {
    setOpenImportDialog(true);
  };

  const handleCloseImportDialog = () => {
    setOpenImportDialog(false);
  };

  return {
    openNewTransactionDialog,
    openImportDialog,
    handleNewButtonClick,
    handleCloseNewTransactionDialog,
    handleImportButtonClick,
    handleCloseImportDialog,
    openNewTransactionDialog,
    openImportDialog,
    handleNewButtonClick,
    handleCloseNewTransactionDialog,
    handleImportButtonClick,
    handleCloseImportDialog
  };
};

export default useHeaderActions;
